export type ProbeResult = 'ok' | 'fail' | 'checking';
export type PillState = 'online' | 'line_down' | 'down' | 'checking';

export interface NasHealth {
  status: string;
  lastStatusChange: string | null;
  lastChecked: string | null;
  heartbeatLastSeen: string | null;
}

const FRESH_MINUTES = 15;

// Browser-side 3-state derivation (spec 2026-07-14-nas-status-pill).
// probe: the tab's own 60s /stream/health-check fetch (fast axis).
// health: the API's heartbeat record, polled every 3 min (amber/red axis).
// While the probe fails but health hasn't arrived, amber + confirming is the
// prior — every real outage so far has been line-down, and it avoids a
// red->amber flash.
export function derivePillState(
  probe: ProbeResult,
  health: NasHealth | null,
  now: Date,
): { state: PillState; confirming: boolean } {
  if (probe === 'checking') return { state: 'checking', confirming: false };
  if (probe === 'ok') return { state: 'online', confirming: false };
  if (!health) return { state: 'line_down', confirming: true };
  const ts = health.heartbeatLastSeen ? Date.parse(health.heartbeatLastSeen) : NaN;
  if (!Number.isNaN(ts) && (now.getTime() - ts) / 60000 < FRESH_MINUTES) {
    return { state: 'line_down', confirming: false };
  }
  return { state: 'down', confirming: false };
}
